import { useState, useCallback } from 'react';

export type ScheduleViewMode = 'list' | 'calendar';

const STORAGE_KEY = 'vehix-schedules-view-preference';

/**
 * Hook to manage and persist the user's preferred schedule view mode.
 * Defaults to 'list' view for familiarity with existing users.
 */
export function useScheduleViewPreference() {
  const [view, setViewState] = useState<ScheduleViewMode>(() => {
    if (typeof window === 'undefined') return 'list';

    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'list' || stored === 'calendar') {
      return stored;
    }
    return 'list'; // Default to list view
  });

  const setView = useCallback((newView: ScheduleViewMode) => {
    setViewState(newView);
    if (typeof window !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, newView);
    }
  }, []);

  return [view, setView] as const;
}

export default useScheduleViewPreference;
